export default "__VITE_ASSET__DhSfPIq3__"